import { watch } from 'vue'

import { localeRef, SUPPORTED_LOCALES } from '@/i18n'
import type { Locale } from '@/types/resume.types'

const STORAGE_KEY = 'um_lang'

// Источник истины по локали — vue-i18n. Здесь синхронизируем её с
// localStorage и атрибутом <html lang>.
watch(
  localeRef,
  (value) => {
    localStorage.setItem(STORAGE_KEY, value)
    document.documentElement.lang = value
  },
  { immediate: true },
)

/**
 * Управление текущей локалью интерфейса (EN/RU/UZ) поверх vue-i18n.
 */
export function useLocale() {
  function setLocale(value: Locale): void {
    localeRef.value = value
  }

  /** Переключает на следующую локаль по кругу: EN → RU → UZ → EN. */
  function toggle(): void {
    const index = SUPPORTED_LOCALES.indexOf(localeRef.value)
    const next = SUPPORTED_LOCALES[(index + 1) % SUPPORTED_LOCALES.length] ?? 'en'
    setLocale(next)
  }

  return { locale: localeRef, setLocale, toggle }
}
